export default __webpack_public_path__ + "static/media/andres_wood_ajuste.2804641f.jpg";